var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { stringify } from 'query-string';
var runOnErrorCallback = function (error) { };
var config = {
    prefix: '',
    defaultHeaders: {},
};
var noop = function () { };
function getHeaders() {
    return __assign({ 'Content-Type': 'application/json' }, config.defaultHeaders);
}
function isEmpty(object) {
    return Object.keys(object || {}).length === 0;
}
function getUrl(url, options) {
    if (!isEmpty(options === null || options === void 0 ? void 0 : options.query)) {
        url = url + "?" + stringify(options.query);
    }
    for (var _i = 0, _a = Object.keys((options === null || options === void 0 ? void 0 : options.params) || {}); _i < _a.length; _i++) {
        var key = _a[_i];
        url = url.replace(":" + key, options.params[key]);
    }
    return config.prefix + "/" + url;
}
export var Api = {
    request: function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(getUrl(url, options), {
                            method: options.method,
                            headers: getHeaders(),
                            body: options.body && JSON.stringify(options.body),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Api.toJson(response)];
                }
            });
        });
    },
    toJson: function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var parsed, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, response.clone().json()];
                    case 1:
                        parsed = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        parsed = response.text();
                        return [3 /*break*/, 3];
                    case 3:
                        if (response.status >= 400) {
                            throw new Error(parsed.message || parsed);
                        }
                        return [2 /*return*/, parsed];
                }
            });
        });
    },
    setPrefix: function (prefix) {
        config.prefix = prefix;
    },
    setAuthorization: function (token) {
        config.defaultHeaders = __assign(__assign({}, config.defaultHeaders), { Authorization: "Bearer " + token });
    },
    setHeaders: function (headers) {
        config.defaultHeaders = __assign(__assign({}, config.defaultHeaders), headers);
    },
    setOnErrorCallback: function (callback) {
        runOnErrorCallback = callback;
    },
};
export function useApiQuery(props) {
    var query = Object.values(props).length === 0 ? props : props.query;
    var _a = props.onSuccess, onSuccess = _a === void 0 ? noop : _a;
    var _b = props.onError, onError = _b === void 0 ? noop : _b;
    var _c = useState({
        response: undefined,
        isLoading: false,
    }), data = _c[0], setData = _c[1];
    var _d = useState(), request = _d[0], setRequest = _d[1];
    useEffect(function () {
        if (request) {
            handlePromise(request.promise);
            return function () { return request.cancel(); };
        }
    }, [request]);
    function handlePromise(promise) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error, errorResponse_1, canUpdateState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setData(function (data) { return (__assign(__assign({}, data), { isLoading: true })); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, promise];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        errorResponse_1 = _a.sent();
                        error = errorResponse_1;
                        runOnErrorCallback(error);
                        return [3 /*break*/, 4];
                    case 4:
                        canUpdateState = !(error && error.isCancelled);
                        if (canUpdateState) {
                            if (error) {
                                setData(function (data) { return (__assign(__assign({}, data), { isLoading: false })); });
                                onError(error);
                            }
                            else {
                                setData({
                                    response: response,
                                    isLoading: false,
                                });
                                onSuccess(response);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        response: data.response,
        isLoading: data.isLoading,
        run: function (params) {
            var cancelable = makeCancelable(query(params));
            setRequest(cancelable);
            return cancelable.promise;
        },
        reset: function () {
            setData(function (data) { return (__assign(__assign({}, data), { response: undefined })); });
        },
    };
}
function makeCancelable(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function (resolve, reject) {
        promise.then(function (result) { return (isCancelled ? reject({ isCancelled: isCancelled }) : resolve(result)); }, function (error) { return (isCancelled ? reject({ isCancelled: isCancelled }) : reject(error)); });
    });
    return {
        promise: wrappedPromise,
        isCancelled: isCancelled,
        cancel: function () { return (isCancelled = true); },
    };
}
